import { MainWebsiteEvents } from "@glamcorner/gc-types/generated/ipcBusEvents";
import { GcSessionInfo } from "@glamcorner/gc-types/generated/types";
import Bus from "../core/Bus";

function replaceFormKey(data: GcSessionInfo) {
  const { formKey } = data;
  const newFormKey = `newFormKey-${formKey}`;
  const formKeySpan = document.querySelector("span#_form_key");

  if (formKeySpan) {
    formKeySpan.textContent = newFormKey;
  }

  document.querySelectorAll("input[name=form_key]").forEach((input: Element) => {
    (input as HTMLInputElement).value = newFormKey;
  });

  document.querySelectorAll("form").forEach((form) => {
    const action = form.getAttribute("action");
    if (action && action.match("form_key")) {
      const newAction = action.replace(/\/form_key\/.+\//, `/form_key/${newFormKey}/`);
      form.setAttribute("action", newAction);
    }
  });
}

export function initialiseReplacementOfFormKeys(bus: Bus) {
  return new Promise((resolve) => {
    document.addEventListener("DOMContentLoaded", () => {
      bus.on(MainWebsiteEvents.GcSessionXhrFinished, {}, (session: GcSessionInfo) => {
        replaceFormKey(session);
        resolve();
      });
    });
  });
}
